/**
 * Sort an array of objects by a property value
 *
 * @param {array} array
 * @param {string} property
 * @param {boolean} convertPropertyValueToNumber
 * @returns
 */
export default function(
    array = [],
    property = "",
    convertPropertyValueToNumber = false
) {
    return array.sort(function(a, b) {
        let aValue = a[property];
        let bValue = b[property];

        if (convertPropertyValueToNumber) {
            aValue = parseInt(aValue);
            bValue = parseInt(bValue);
        }

        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
    });
}



// WEBPACK FOOTER //
// ./src/js/utilities/sort-by-prop.js